import {SpotlightSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {useIsConsentBannerClosed} from '@aboutyou/storage';
import {
  SpotlightAmbientSlider as BaseSpotlightAmbientSlider,
  SPACING,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {BackgroundCard} from './BackgroundCard';
import {Slide} from './Slide';
import {useSpotlightSliderUniqueRenderKey} from './useSpotlightSliderUniqueRenderKey';
import {spotlightSliderAmbientHeightCSS} from './utils';

export const SpotlightSliderAmbient: FC<
  SpotlightSection & {className?: string; isFetching?: boolean}
> = ({className, elements, isFetching}) => {
  const uniqueKey = useSpotlightSliderUniqueRenderKey(elements, isFetching);
  const isConsentBannerClosed = useIsConsentBannerClosed();

  return (
    <Spacer className={className}>
      <Container>
        <BaseSpotlightAmbientSlider
          slides={elements}
          CardComponent={Slide}
          BackgroundComponent={BackgroundCard}
          uniqueKey={uniqueKey}
          isInitialAutoplayStopped={!isConsentBannerClosed}
        />
      </Container>
    </Spacer>
  );
};

const Spacer = styled.div`
  ${spotlightSliderAmbientHeightCSS}

  margin: 16px 16px ${SPACING['X.Md']};
`;

const Container = styled.div`
  position: relative;
  height: var(--slider-height);
  overflow: hidden;
  border-radius: 16px;
`;
